import React from 'react';
import { Card } from 'react-bootstrap';

import { useTranslation } from 'react-i18next';
import moment from 'moment';

const BenefitCard = ({ Data }) => {
  const { t } = useTranslation();

  const getBenefitPeriod = (from, to) => {
    return `${moment(from).format('MMM')} ${moment(from).format(
      'YYYY',
    )} - ${moment(to).format('MMM')} ${moment(to).format('YYYY')}`;
  };
  return (
    <>
      <div className="carousel-li-item">
        <div className="item-wrapper">
          <Card>
            <Card.Body>
              <div className="card-body-wrapper">
                <h5>
                  {`${t('member.pages.coverages.coverage_period')}: `}{' '}
                  {getBenefitPeriod(
                    Data?.BenefitStartDate,
                    Data?.BenefitThruDate,
                  )}
                </h5>
              </div>
              <div className="pt-2">
                <table className="w-100">
                  <tr>
                    <td className="text-left w-70">Before Tax</td>
                    <td className="text-right bold">{`$${Data?.BeforeTax}`}</td>
                  </tr>
                  <tr>
                    <td className="text-left w-70">
                      Social Security Tax Amount
                    </td>
                    <td className="text-right bold">{`$${Data?.totFICATax}`}</td>
                  </tr>
                  <tr>
                    <td className="text-left w-70">Medicare Tax Amount </td>
                    <td className="text-right bold">{`$${Data?.totMedicareTax}`}</td>
                  </tr>
                  <tr>
                    <td className="text-left w-70">After Tax</td>
                    <td className="text-right bold">{`$${Data?.AfterTax}`}</td>
                  </tr>
                  <tr>
                    <td className="text-left w-70">
                      <h5>{t('member.pages.coverages.total_paid')}</h5>
                    </td>
                    <td className="text-right">
                      <h4>{`$${Data?.TotPaid}`}</h4>
                    </td>
                  </tr>
                </table>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default BenefitCard;
